<template>
  <div class="index">
    <div class="index_main">
        <img class="shop_icon"  @click.stop="toggleShow()" src="@/assets/img/shop_icon.png">
      <transition enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutDown">
        <div class="main_centent" v-show="show">
          <div class="centent_title">
            <div class="name">待确认课程</div>
            <div class="el-icon-close" @click.stop="toggleShow()"></div>
          </div>
          <div class="centent_box">
            <div class="box_list" v-for="(item,index) in goods" :key="index">
              <div class="box_list_left">
                <img :src="item.images_url" />
              </div>
              <div class="box_list_centent">
                <div class="c_title">{{item.name}}</div>
                <div class="c_school">课时：{{item.studyHours}}/时</div>
                <div class="category">
                  <span v-if="item.category_id==19">现场专业人员</span>
                  <span v-else>暂无分类</span>
                </div>
              </div>
              <div class="el-icon-delete" @click.stop="toggleDeleteIndex(index)"></div>
            </div>
          </div>
          <div class="centent_length">已选：<span>{{schoolnum}}</span> 课时</div>
          <div class="centent_peration">
            <div class="el-icon-delete" @click.stop="toggleDelete()">
              <div class="span">清空</div>
            </div>
            <div class="button" @click="toggleDetermine">确定</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
    import Utils from '@/utils/transfer.js'
    import {PostSaveByData} from '@/api/new/order'
    export default {
        name: "Index",
        data(){
            return{
                show:false,
                goods:[],
                is_empty:true
            }
        },
        computed:{
            schoolnum(){
                let goods = this.goods
                let num = 0
                for (var i=0;i<goods.length;i++){
                    num = num+goods[i].studyHours
                }
                return num;
            }
        },
        mounted() {
            Utils.$on('trade', (msg) => {
                let goods = JSON.parse(localStorage.getItem('goods'));
                if(goods!==null){
                    this.goods = goods
                }
            })
        },
        methods:{
            toggleDeleteIndex(index){
                let goods = this.goods
                goods.splice(index,1)
                this.goods = goods
                localStorage.setItem('goods', JSON.stringify(goods))
            },
            toggleDetermine(){
                let goods = JSON.parse(localStorage.getItem('goods'));
                if(goods==null || goods.length==0){
                    this.show = !this.show
                    return
                }
                //进行提交课程操作，成功后进入个人中心
                let user = JSON.parse(localStorage.getItem('userinfo'));
                let temp = {
                    total_hours:this.schoolnum,//已选课时
                    studyHours:user.studyHours,//当前岗位硬性规定课时
                    identityCard:user.identityCard,
                    goods:goods
                }
                if(this.schoolnum>user.studyHours){
                    this.$message({
                        type: 'warning',
                        message: '超出规定课时，请减少课程。'
                    });
                    return;
                }
                PostSaveByData(temp).then(res=>{
                    if(res.code==20000){
                        let goods = []
                        this.goods = goods
                        localStorage.setItem('goods', JSON.stringify(goods))
                        this.show = !this.show
                        this.$router.push({path: '/my'})
                    }
                    if(res.code==10001){
                        this.$alert(res.msg, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$message({
                                    type: 'warning',
                                    message: '请注意查看提示内容'
                                });
                            }
                        });
                    }
                })
            },
            toggleShow(){
                this.show = !this.show
                let goods = JSON.parse(localStorage.getItem('goods'));
                if(goods!==null){
                    this.goods = goods
                }
            },
            //清空全部
            toggleDelete(){
                this.$confirm('确认清空您加入的待选课程, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '清空成功!'
                    });
                    let goods = []
                    this.goods = goods
                    localStorage.setItem('goods', JSON.stringify(goods))
                    this.show = !this.show
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除11'
                    });
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  ::-webkit-scrollbar {
    width: 0 !important;height: 0;
  }
.index_main{
  width: 80px;
  height: 80px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 2px 8px 0 #ddd;
  position: relative;
  .main_centent{
    position: absolute;
    right: 85px;
    bottom: -100px;
    width: 350px;
    height: 450px;
    border: 1px solid #eee;
    background-color: #fff;
    box-shadow: 0 2px 8px 0 #ddd;
    border-radius: 10px;
    padding: 10px;
    .centent_title{
      position: relative;
      border-bottom: 1px solid #5fa53c;
      padding: 10px 0;
      color: #999;
      font-size: 14px;
      .name{
        text-align: center;
      }
      .el-icon-close{
        position: absolute;
        right: 0px;
        top: 0;
        font-size: 20px;
        color: #999;
        cursor: pointer;
        &:hover{
          color: #343434;
        }
      }
    }
    .centent_box{
      height: 340px;
      overflow-y: auto;
      .box_list{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid #eee;
        .box_list_left{
          width: 100px;
          height: 80px;
          img{
            width: 100%;
            height: 100%;
            object-fit: revert;
            border-radius: 6px;
          }
        }
        .box_list_centent{
          width: 210px;
          height: 80px;
          margin-left: 10px;
          .c_title{
            font-size: 13px;
            height: 40px;
            overflow: hidden;
            word-break: break-all;  /* break-all(允许在单词内换行。) */
            text-overflow: ellipsis;  /* 超出部分省略号 */
            display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
            -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
            -webkit-line-clamp: 2; /** 显示的行数 **/
          }
          .c_school{
            font-size: 12px;
            color: lightcoral;
          }
          .category{
            margin-top: 3px;
            span{
              padding: 2px 8px;
              background-color: orange;
              color: #fff;
              font-size: 12px;
              border-radius: 3px;
            }
          }

        }
        .el-icon-delete{
          width: 30px;
          text-align: center;
          height: 80px;
          line-height: 80px;
          font-size: 18px;
          cursor: pointer;
          color: #999999;
          &:hover{
            color: #1a1a1a;
          }
        }
      }
    }
    .centent_length{
      font-size: 14px;
      height: 30px;
      line-height: 30px;
      span{
        margin: 0 5px;
        color: orangered;
      }
    }
    .centent_peration{
      border-top: 1px solid #eee;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      .el-icon-delete{
        color: #999999;
        font-size: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:hover{
          color: #1a1a1a;
        }
        .span{
          font-size: 12px;
        }
      }
      .button{
        width: 80px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #fff;
        border-radius: 5px;
        background-color: #40af71;
        font-size: 12px;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
    }
  }
  .shop_icon{
    width: 45px;
    height: 45px;
    cursor: pointer;
  }
}
</style>